<script setup lang="ts">
import {ExclamationTriangleIcon} from "@heroicons/vue/24/outline";
import {i18n} from "@/services/support/i18n";

interface Props {
  showText?: boolean,
  text?: string
}

withDefaults(defineProps<Props>(), {showText: false, text: ""});
</script>

<template>
  <div class="flex items-center gap-3">
    <ExclamationTriangleIcon class="h-8 w-8 text-orange-500" :title="i18n.loadingError"/>
    <span v-if="showText">{{ text }}</span>
  </div>
</template>

